import Util from '../../../lib/util.jsx'
import routes from '../../../../shared/routes.js'

export function canDeletePurchaseOrder ({ purchaseOrder, acl }) {
  if (!acl) {
    throw new Error('No ACL passed in.')
  }

  if (!purchaseOrder) {
    throw new Error('No purchaseOrder passed in.')
  }

  if (acl.isRoleFinance()) {
    // A PO can always be deleted by a user with the finance role.
    return true
  } else if (acl.isRoleProjectManager() && purchaseOrder.expensesBooked === 0) {
    // A PO can always be deleted by user with project manager role when no costs have been booked on the PO.
    return true
  } else {
    return false
  }
}

export function getDownloadUrl ({ purchaseOrder, teamId, userId }) {
  const filename = Util.getPdfFileName('purchaseorder', purchaseOrder.invoiceNo, purchaseOrder.status)

  return `${routes.PURCHASEORDER_PREVIEW}/${teamId}/${userId}/${purchaseOrder.id}/${filename}`
}
